module.exports = __webpack_public_path__ + "static/img/logo31.0d67242.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo31.png
// module id = U7rT
// module chunks = 1